import React, { Component } from 'react'
import *as s from './PartnerModule.module.css'
import { StaticImage } from 'gatsby-plugin-image'
export default class PartnerModule extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                 <div className={s.container}>
                    <div className={s.subtitleModule}>
                        <StaticImage src="../../../images/ansprechpartner.svg" alt="information icon" className={s.subtitleIcon}/>
                        <h2 >Ansprechpartner</h2>
                    </div>
                    <div className={s.partnerModules}>
                        <div className={s.partnerBlok}>
                             <StaticImage src="../../../images/man.svg" alt="information icon" className={s.portret}/>
                             <div className={s.textBlok}>
                                   <h2 className={s.name}>Max Mustermann <br /> Beratung und Coaching</h2 >
                                   <div className={s.contacts}>
                                       <div className={s.contact}>
                                            <StaticImage src="../../../images/mail.svg" alt="information icon" className={s.icon}/>
                                            <a className={s.text} href='tel:+49(176)-84-777-405' >+49 176 84 777 405</a> <br />
                                       </div>
                                       <div className={s.contact}>
                                            <StaticImage src="../../../images/phone.png" alt="information icon" className={s.icon}/>
                                            <a className={s.text} href='mailto:m.mustermann@ihk.de' >m.mustermann@ihk.de</a>
                                       </div>
                                   </div>
                             </div>
                        </div>
                        <div className={s.partnerBlok}>
                             <StaticImage src="../../../images/man.svg" alt="information icon" className={s.portret}/>
                             <div className={s.textBlok}>
                                   <h2 className={s.name}>Judit Musterfrau <br /> Kundenservice</h2 >
                                   <div className={s.contacts}>
                                       <div className={s.contact}>
                                            <StaticImage src="../../../images/mail.svg" alt="information icon" className={s.icon}/>
                                            <a className={s.text} href='tel:+49(176)-84-777-405' >+49 176 84 777 405</a> <br />
                                       </div>
                                       <div className={s.contact}>
                                            <StaticImage src="../../../images/phone.png" alt="information icon" className={s.icon}/>
                                            <a className={s.text} href='mailto:m.mustermann@ihk.de' >j.musterfraun@ihk.de</a>
                                       </div>
                                   </div>
                             </div>
                        </div>
                     </div>
                </div> 
            </div>
        )
    }
}
